import { Typography } from "@mui/material";
import Box from "@mui/material/Box";
import Tooltip from "@mui/material/Tooltip";

const APCalculation = ({
  name,
  value,
  tooltip,
}: {
  name: string;
  value: string;
  tooltip?: string;
}) => {
  return (
    <Box
      sx={{ display: "flex", columnGap: 4, justifyContent: "space-between" }}
    >
      <Tooltip title={tooltip}>
        <Typography variant="titleSmall">{name}</Typography>
      </Tooltip>
      <Box>
        <Typography variant="bodyMedium">{value}</Typography>
      </Box>
    </Box>
  );
};

export default APCalculation;
